"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Log_1 = __importDefault(require("./Log"));
class Util {
    static timeout(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
    static took(start) {
        return Date.now() - start + " ms";
    }
    static shaHuman(sha) {
        if (sha !== null && typeof sha === "string" && sha.length > 6) {
            return sha.substr(0, 6);
        }
        return sha;
    }
    static tookHuman(start, end, shortForm, pad) {
        if (typeof end === "undefined") {
            end = Date.now();
        }
        if (typeof shortForm === "undefined") {
            shortForm = false;
        }
        if (typeof pad === "undefined") {
            pad = false;
        }
        if (start > end) {
            [start, end] = [end, start];
        }
        let msg = "";
        const delta = end - start;
        const deltaSec = Math.floor(delta / 1000);
        const hours = Math.floor(deltaSec / 3600);
        const minutes = Math.floor((deltaSec - hours * 3600) / 60);
        const seconds = Math.floor(deltaSec - hours * 3600 - minutes * 60);
        if (shortForm === true) {
            if (delta < 1000 * 10) {
                let ret = delta + " ms";
                if (pad) {
                    ret = ret.padStart(12, " ");
                }
                return ret;
            }
            if (hours > 0) {
                msg = hours + "h";
            }
            if (hours > 0 || minutes > 0) {
                if (minutes < 10) {
                    msg = msg + " 0" + minutes + "m";
                }
                else {
                    msg = msg + " " + minutes + "m";
                }
            }
            if (hours > 0 || minutes > 0 || seconds > 0) {
                if (seconds < 10) {
                    msg = msg + " 0" + seconds + "s";
                }
                else {
                    msg = msg + " " + seconds + "s";
                }
            }
            if (pad) {
                msg = msg.padStart(12, " ");
            }
        }
        else {
            if (delta < 1000) {
                return delta + " ms";
            }
            if (hours > 1) {
                msg = hours + " hours";
            }
            else if (hours === 1) {
                msg = hours + " hour";
            }
            if (hours > 0) {
                if (minutes === 1) {
                    msg = msg + " and 1 minute";
                }
                else if (minutes > 1) {
                    msg = msg + " and " + minutes + " minutes";
                }
            }
            else {
                if (minutes === 1) {
                    msg = "1 minute";
                }
                else {
                    msg = minutes + " minutes";
                }
            }
            if (hours < 1) {
                if (minutes > 0) {
                    if (seconds === 0) {
                    }
                    else if (seconds === 1) {
                        msg = msg + " and 1 second";
                    }
                    else {
                        msg = msg + " and " + seconds + " seconds";
                    }
                }
                else {
                    if (seconds === 0) {
                    }
                    else if (seconds === 1) {
                        msg = "1 second";
                    }
                    else {
                        msg = seconds + " seconds";
                    }
                }
            }
            if (pad) {
                msg = msg.padStart(40, " ");
            }
        }
        return msg;
    }
    static delay(ms) {
        const start = Date.now();
        return new Promise(function (resolve) {
            const fire = new Date(start + ms);
            Log_1.default.trace("Util::delay( " + ms + " ms ) - waiting; will trigger at " + fire.toLocaleTimeString());
            setTimeout(function () {
                const actual = Date.now();
                const took = actual - start;
                const delta = actual - fire.getTime();
                Log_1.default.trace("Util::delay( " + ms + " ms ) - fired; took: " + took + " ms; jitter: " + delta + " ms");
                resolve();
            }, ms);
        });
    }
    static clone(a) {
        return JSON.parse(JSON.stringify(a));
    }
    static toBoolean(value) {
        const strValue = String(value).toLowerCase().trim();
        return strValue === "true" || strValue === "yes" || strValue === "1";
    }
    static toInteger(value, fallback) {
        try {
            const num = parseInt(value, 10);
            if (isNaN(num) === false) {
                return num;
            }
        }
        catch (err) {
            Log_1.default.warn("Util::toInteger( " + value + ", " + fallback + " ) - ERROR: " + err.message);
        }
        Log_1.default.trace("Util::toInteger( " + value + ", " + fallback + " ) - value not an integer; returning fallback");
        return fallback;
    }
    static isNumeric(value) {
        return !isNaN(value - parseFloat(value));
    }
    static compare(a, b) {
        if (typeof a === typeof b && a === b) {
            return 0;
        }
        if ((a === null || a === undefined) && (b === null || b === undefined)) {
            return 0;
        }
        if ((a === null || a === undefined) && b !== null && b !== undefined) {
            return -1;
        }
        if ((b === null || b === undefined) && a !== null && a !== undefined) {
            return 1;
        }
        if (Array.isArray(a) || Array.isArray(b)) {
            Log_1.default.trace("Util::compare( " + a + ", " + b + " ) - punt on arrays");
            return 0;
        }
        if (typeof a === "object" || typeof b === "object") {
            Log_1.default.trace("Util::compare( " + a + ", " + b + " ) - punt on objects");
            return 0;
        }
        if (Util.isNumeric(a) && !Util.isNumeric(b)) {
            return 1;
        }
        if (Util.isNumeric(b) && !Util.isNumeric(a)) {
            return -1;
        }
        if (Util.isNumeric(a) && Util.isNumeric(b)) {
            const numA = parseFloat(a);
            const numB = parseFloat(b);
            if (numA === numB) {
                return 0;
            }
            else if (numA < numB) {
                return -1;
            }
            else {
                return 1;
            }
        }
        return ("" + a).localeCompare("" + b);
    }
    static processConcurrently(items, concurrency, worker) {
        return __awaiter(this, void 0, void 0, function* () {
            if (Array.isArray(items) === false || items.length === 0) {
                return [];
            }
            let limit = Math.floor(concurrency);
            if (isNaN(limit) === true || limit < 1) {
                limit = 1;
            }
            if (limit > items.length) {
                limit = items.length;
            }
            const results = new Array(items.length);
            let nextIndex = 0;
            let firstError = null;
            const runner = () => __awaiter(this, void 0, void 0, function* () {
                while (firstError === null) {
                    const index = nextIndex;
                    nextIndex++;
                    if (index >= items.length) {
                        return;
                    }
                    try {
                        results[index] = yield worker(items[index], index);
                    }
                    catch (err) {
                        if (firstError === null) {
                            firstError = err;
                        }
                        return;
                    }
                }
            });
            const runners = [];
            for (let i = 0; i < limit; i++) {
                runners.push(runner());
            }
            yield Promise.all(runners);
            if (firstError !== null) {
                throw firstError;
            }
            return results;
        });
    }
    static redactSecrets(text, secrets) {
        if (typeof text !== "string" || text.length === 0) {
            return text;
        }
        let redacted = text.replace(/([a-zA-Z][a-zA-Z0-9+.-]*:\/\/)[^@\s/]+@/g, "$1<REDACTED>@");
        if (Array.isArray(secrets) === true) {
            for (const secret of secrets) {
                if (typeof secret === "string" && secret.length >= 8) {
                    redacted = redacted.split(secret).join("<REDACTED>");
                }
            }
        }
        return redacted;
    }
}
exports.default = Util;
